export default __webpack_public_path__ + "static/media/bolt.f16ac1d9.svg";